import { IWidget } from 'common/schema/widget/Widget';
import { WidgetInputViewType } from 'common/schema/widget/input/WidgetInputViewType';

export function getWidgetInputViewType(widget: IWidget): WidgetInputViewType {
  const input = widget.input!;
  return input.view;
}
